export default {
  // 教学成效学习进度
  StuLearningProgress:'',
  stuActivityTake:'',//活动参与率
  stuActivitytime:'',//活跃组织次数
  stuAttendance:'',//考勤预警
  stuPrepareWarning:'',//预习预警
  stuJobWarning:'',//作业预警
  stuActivityWarning:'',//活动预警
  stuEvaluate:'',//过程性评价
  stuTeachDetail:'',//教学明细表
  stuHeadrInformation:'',//学生头部信息
}



// WEBPACK FOOTER //
// ./src/store/effect/states.js